
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-users" })
export default class IconUsers extends Vue {
  sData: string = require("@icon/feather/users.svg");
}
